import "jquery-validation";
import "jquery-validation/dist/additional-methods";
import { scrollToErrorBlock } from "./helpers";

export const validationRulesObj = {
  errorClass: "form-control--error",
  errorElement: "span",
  errorGroupClass: "form-group--error",
  errorPlacement: function (error, element) {
    const errorParentNode = element.closest(".form-group");
    const errorTargetElement = errorParentNode.find("legend");
    const errorParentLabel = errorParentNode.find("label");

    //console.log(error, element, errorTargetElement);
    if (errorTargetElement.length) {
      error.insertBefore(errorTargetElement);
    } else {
      error.insertAfter(errorParentLabel);
    }
  },
  highlight: function (element, errorClass, validClass) {
    $(element).closest(".form-group").addClass(this.settings.errorGroupClass);
    $(element).addClass(errorClass);
    scrollToErrorBlock();
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).removeClass(errorClass);
    if (
      $(element).closest(".form-group").find("input.form-control--error")
        .length === 0
    ) {
      $(element)
        .closest(".form-group")
        .removeClass(this.settings.errorGroupClass);
    }
  },
};

//Validation class rules
$.validator.addClassRules({
  "js-mandatory": {
    required: true,
  },
  "js-phone-num": {
    phonesUK: true,
  },
  "js-email": {
    email: true,
  },
  "js-level-checkbox": {
    checkboxRequiredIfQty: true,
  },
  "js-file-upload": {
    checkFileRequired: true,
    extension: "jpg|jpeg|png|gif|bmp|pdf|doc|docx",
  },
});

export function validateForm() {
  $(".js-main-form").validate(validationRulesObj);
}

$.validator.addMethod(
  "checkboxRequiredIfQty",
  function (value, element) {
    const cardId = $(element).data("card-id");
    const qty = $(`.js-copy-count[data-card-id='${cardId}']`).val();
    const $checkboxes = $(`.js-level-checkbox[data-card-id='${cardId}']`);

    // if quantity < 1, remove any existing error and pass
    if (parseInt(qty, 10) < 1) {
      $checkboxes.removeClass("error");
      return true;
    }

    // only evaluate on the *first* checkbox in the group
    // this is to avoid the same err message appearing multiple times
    if (element !== $checkboxes.first()[0]) return true;

    // check if at least one is checked
    return $checkboxes.filter(":checked").length > 0;
  },
  "Please select a Level from the list "
);

$.validator.addMethod(
  "checkFileRequired",
  function (value, element) {
    // check if there's a file selected or if we have an uploaded file already
    const hasSelectedFile = element.files && element.files.length > 0;
    const hasUploadedFile =
      $(".js-hidden-uploaded-file-info").val() &&
      JSON.parse($(".js-hidden-uploaded-file-info").val()).name;

    return hasSelectedFile || hasUploadedFile;
  },
  "Select a file to upload"
);
